import i18next from 'i18next';
import moment from 'moment';
import React from 'react';
import Strong from '~/components/Strong';

export const teamEmployeeTable = (isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (text, record) => (
          <div>
            <Strong>{i18next.t('Evento')}:</Strong> {record?.event?.name}
            <br />
            <Strong>{i18next.t('Data')}:</Strong> {record?.departure_at}
            <br />
            <Strong>{i18next.t('Operação')}:</Strong> {record?.operational_name}
            <br />
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('Evento'),
      dataIndex: ['event', 'name'],
      key: 'event.name',
      render: (text) => text,
    },
    {
      title: i18next.t('Data'),
      dataIndex: 'departure_at',
      key: 'departure_at',
      render: (text) => text && moment(text).format('DD/MM/YYYY'),
    },
    {
      title: i18next.t('Operação'),
      dataIndex: 'operational_name',
      key: 'operational_name',
      render: (text) => text,
    },
  ];
};
